import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Chart, ChartDataset, Plugin } from 'chart.js/auto';

interface CustomBarDataset extends ChartDataset<'bar'> {
  labelColors?: string[];
}

@Component({
  selector: 'aggregator-dashboard-horizontal-bar-chart',
  templateUrl: './horizontal-bar-chart.component.html',
  styleUrl: './horizontal-bar-chart.component.scss',
  standalone: true,
  imports: [],
})
export class DashboardHorizontalBarChartComponent implements OnInit {
  @ViewChild('chartRef', { static: true })
  chartCanvas!: ElementRef<HTMLCanvasElement>;

  chart!: Chart;

  ngOnInit(): void {
    this.createChart();
  }

  createChart(): void {
    // Get the 2D context of the canvas
    const ctx = this.chartCanvas.nativeElement.getContext('2d');
    if (!ctx) {
      return;
    }

    // Create a new Chart instance
    this.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: ['Подземные', 'Наземные', 'Многоуровневые', 'Уличные'],
        datasets: [
          {
            label: 'Количество: ',
            data: [450, 190, 123, 512],
            backgroundColor: ['#015f66', '#028a99', '#00BCD4', '#4ddbe5'],
            borderColor: ['#015f66', '#028a99', '#00BCD4', '#4ddbe5'],
            borderRadius: 8,
            categoryPercentage: 1,
            barPercentage: 1,
            borderWidth: 0,
            // Our custom property with text colors
            labelColors: ['white', 'white', 'white', 'black'],
          } as CustomBarDataset,
        ],
      },
      options: {
        indexAxis: 'y',
        interaction: {
          mode: 'index',
          intersect: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false, // Hide the legend
          },
        },
        scales: {
          y: {
            display: false,
            grid: {
              display: false, // Hide vertical grid lines
            },
            // Each bar within that group is 70% of the total group width
          },
          x: {
            display: false,
            beginAtZero: true,
            grid: {
              display: false, // Hide vertical grid lines
            },
          },
        },
      },
      plugins: [BarLabelPlugin],
    });
  }
}

export const BarLabelPlugin: Plugin<'bar'> = {
  id: 'BarLabelPlugin',

  afterDatasetsDraw(chart) {
    const { ctx } = chart;

    // 👇 теперь TS знает, что у нас баровые датасеты
    (chart.data.datasets as CustomBarDataset[]).forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex);

      meta.data.forEach((bar, index) => {
        const rawValue = dataset.data[index];
        if (rawValue == null) return;

        // кастомное свойство
        const textColor = dataset.labelColors?.[index] ?? 'black';

        const categoryLabel = chart.data.labels ? chart.data.labels[index] : '';
        const labelText = `${categoryLabel}: ${rawValue}`;

        const { x, y } = bar.getProps(['x', 'y'], true);

        ctx.save();
        ctx.fillStyle = textColor;
        ctx.font = 'bold 12px sans-serif';
        ctx.textAlign = 'right';
        ctx.textBaseline = 'middle';

        ctx.fillText(labelText, x - 6, y);
        ctx.restore();
      });
    });
  },
};
